import React from 'react';
import { CircleSpinner, IconPlus } from '../../../assets/svg';
import useWindowSize from '../../../hooks/useWindowSize';

export const ResponsiveButton = ({
    breakpoint = 768,
    onClick,
    title,
    label,
    icon = <IconPlus />,
    id = 'action-btn',
    customRef = undefined,
    isLoading = false,
    leftIcon = undefined,
    rightIcon = undefined,
    isWhite = false,
}) => {
    const { width } = useWindowSize(customRef);
    return width < breakpoint ? (
        <button type='button' id={id} className='bg-transparent' title={title} onClick={onClick}>
            {isLoading ? <CircleSpinner /> : icon}
        </button>
    ) : (
        <button
            aria-label={title}
            title={title}
            className={
                isWhite
                    ? 'ssc-secondary-white-btn text-nowrap'
                    : 'ssc-primary-green-btn-small text-nowrap'
            }
            onClick={onClick}
        >
            {
                <span className='me-1'>
                    {isLoading ? <CircleSpinner /> : leftIcon ? leftIcon : null}
                </span>
            }
            {label || title}
            {rightIcon ? rightIcon : null}
        </button>
    );
};
